import { render } from "./SocialCategories.vue?vue&type=template&id=ad4c54ac"
import script from "./SocialCategories.vue?vue&type=script&lang=js"
export * from "./SocialCategories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__